import React, { Component } from "react"
import Jumbotron from 'react-bootstrap/Jumbotron'

export default class Home extends Component {
  displayName = Home.name;

  render() {
    return (
      <div className="container-fluid">
        <div className="row justify-content-center mt-5">
          <Jumbotron className="col-auto text-center px-5 py-4 mx-auto">
            <h1>Service Portal</h1>
            <p>Welcome to the Sivantos service portal for telecare</p>
            <p>Please select the different services available from the menu</p>
          </Jumbotron>
        </div>
      </div>
    )
  }
}